import Rellax from 'rellax';

const SELECTOR = '.js-parallax';

// Rellax moves every element the same number of pixels for a given speed
// value (speed * 100px, see rellax.js), regardless of the element's own
// height. That reads as "too slow" on a tall image (the shift is a tiny
// fraction of its height) and "too fast" on a short one (same shift, much
// bigger fraction) — exactly the size-dependent feel reported. Scaling each
// element's speed by its own rendered height against a reference keeps the
// shift a roughly constant proportion of the image, whatever size it is.
const REFERENCE_HEIGHT = 700;
const MIN_SCALE = 0.4;
const MAX_SCALE = 2;

function scaleSpeeds() {
  document.querySelectorAll(SELECTOR).forEach((el) => {
    const baseSpeed = parseFloat(el.dataset.rellaxSpeed || '-1');
    const height = el.offsetHeight;

    if (!height) return;

    const scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, height / REFERENCE_HEIGHT));

    el.setAttribute('data-rellax-speed', (baseSpeed * scale).toFixed(2));
  });
}

export default function setParallax() {
  if (!document.querySelector(SELECTOR)) return;

  scaleSpeeds();

  const rellax = new Rellax(SELECTOR, {
    center: true,
  });

  // Rellax caches every element's bounding rect once, at init. Anything that
  // reflows the page afterwards without a resize event (e.g. the room
  // filters block hiding/showing cards) leaves that cache stale, so visible
  // elements can inherit another element's old offset. Exposed on `window`
  // so scripts bundled as separate Vite entries (blocks) can request a
  // recalculation instead of each needing their own Rellax instance.
  window.rellax = rellax;
}
